import React from "react";
import EditRiskScores from "./edit-risk-scores";

const RiskFundManagement = React.lazy(() => import("./risk-fund-management"));
const EditRisk = React.lazy(() => import("./edit-risk"));

export { RiskFundManagement, EditRisk ,EditRiskScores};
